export const ETHEREUM_MAINNET_CHAIN_ID = '1';
export const ETHEREUM_TESTNET_CHAIN_ID = '11155111';

export const STARKNET_MAINNET_CHAIN_ID = 'SN_MAIN';
export const STARKNET_TESTNET_CHAIN_ID = 'SN_SEPOLIA';

export const LOCAL_STORAGE_KEY = 'ls-paradex-accounts';
